

import {Component, Mixins, Prop} from "vue-property-decorator";
import {ITarafBilgisiDetayliTarafRollu} from "@/plugins/uyap-plugin/uyap/GetDosyaTarafListesiWithTarafRol";
import SimpleInputMixin from "@/mixins/SimpleInputMixin.vue";
import FormDialog from "@/components/dialogs/FormDialog.vue";
import UcuncuTarafForm from "@/components/forms/form-wizard/eicrapro/UcuncuTarafForm.vue";

@Component({
  components: {UcuncuTarafForm, FormDialog}
})

export default class DosyaAraciKisiKurumTarafListesiPicker extends Mixins(SimpleInputMixin) {
  @Prop({required: true}) dosyaId!: string;
  @Prop() rules!: string;
  @Prop() showUyapIcon!: string | boolean;
  @Prop() tooltip!: string;
  @Prop() showTarafEkle!: string | boolean;
  @Prop() label!: string;
  @Prop() maasHaczi!: string | boolean;

  items: Array<ITarafBilgisiDetayliTarafRollu> = [];
  localValue: any = null;
  isLoading: boolean = false;


  get isShowUyapIcon() {
    return this.showUyapIcon || this.showUyapIcon === "";
  }

  get isShowTarafEkle() {
    return this.showTarafEkle || this.showTarafEkle === "";
  }

  get isMaasHaczi() {
    return this.maasHaczi || this.maasHaczi === "";
  }

  onKurumChange(v: ITarafBilgisiDetayliTarafRollu) {
    const selected = this.items.find(item => item.guncelKisiKurumId == this.localValue);
    this.$emit("kurumAdi", selected?.tarafAdi);
    this.input();
  }

  created() {
    this.load();
  }

  async load() {
    try {
      this.isLoading = true;
      const response = await this.$uyap.GetDosyaTarafListesiWithTarafRol().run({
        dosyaId: this.dosyaId,
        islemTuru: this.isMaasHaczi ? 71 : 26,
      });
      this.items = response;
    } catch (e) {
      this.$toast.error(e.message);
    } finally {
      this.isLoading = false
    }
  }

  async handleSuccess(newPersonData: ITarafBilgisiDetayliTarafRollu) {
    await this.load();
    this.localValue = newPersonData.guncelKisiKurumId;
  }
}
